// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-page_App__h1tx4 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.tournament-page_Icons__klo2c {
    width: 80%;
    max-width: 80%;
}

.tournament-page_Content__CLaD5 {
    width: 80%;
    height: 80%;
    max-width: 80%;
    max-height: 80%;
    background-color: white;
    border-radius: 16px;

    display: flex;
    flex-direction: column;
}

.tournament-page_loading__Fhmfj {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(206, 206, 206, 0.486);
}

@media (max-width: 768px) {
    .tournament-page_App__h1tx4 {
        height: calc(100% - 50px);
    }
    .tournament-page_Content__CLaD5 {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        border-radius: 0;

        >div:nth-child(1) >div >div{
            overflow: auto !important;
        }
    }
    .tournament-page_Icons__klo2c {
        position: absolute;
        z-index: 10;
        top: 0;
        right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsPageN/ui/tournament-page.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,gBAAgB;;QAEhB;YACI,yBAAyB;QAC7B;IACJ;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,MAAM;QACN,QAAQ;IACZ;AACJ","sourcesContent":[".App {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.Icons {\n    width: 80%;\n    max-width: 80%;\n}\n\n.Content {\n    width: 80%;\n    height: 80%;\n    max-width: 80%;\n    max-height: 80%;\n    background-color: white;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: column;\n}\n\n.loading {\n    z-index: 1;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(206, 206, 206, 0.486);\n}\n\n@media (max-width: 768px) {\n    .App {\n        height: calc(100% - 50px);\n    }\n    .Content {\n        width: 100%;\n        height: 100%;\n        max-width: 100%;\n        max-height: 100%;\n        border-radius: 0;\n\n        >div:nth-child(1) >div >div{\n            overflow: auto !important;\n        }\n    }\n    .Icons {\n        position: absolute;\n        z-index: 10;\n        top: 0;\n        right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `tournament-page_App__h1tx4`,
	"Icons": `tournament-page_Icons__klo2c`,
	"Content": `tournament-page_Content__CLaD5`,
	"loading": `tournament-page_loading__Fhmfj`
};
export default ___CSS_LOADER_EXPORT___;
